module.exports = __webpack_public_path__ + "img/ganador.c19a139f.png";